import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class CollectionService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 1218
     * @datataskName sp_ws_p2_collection_list
     * @param params
     * @return promise containing list of collections.
     */
    public getCollections(params?: GetCollectionsParams): Promise<CollectionItem[]> {
        return this.datatask.Post(1218, params);
    }
}

export interface GetCollectionsParams {
    isactive: '1' | '0';
}

export interface CollectionItem {
    item_id: string;
    item_name: string;
    item_path: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    item_filtervalue: string;
}
